
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service/unsubscribe",
      function () {
        return require("private-next-pages/customer-service/unsubscribe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service/unsubscribe"])
      });
    }
  